import React, {useState, useEffect, useRef} from "react";
import Select from "react-select";
import Button from "./Button";
import {ChevronDownIcon} from "@common/icons";

const ButtonSelect = props => {
    const {title, type = 'text', position, options, value, onChange} = props;
    const [selectValue, setSelectValue] = useState([]);
    const [isOpen, setOpen] = useState(false);

    const toggleOpen = () => {
        setOpen(!isOpen);
    }
    const handleSelectChange = newValue => {
        setOpen(false);
        setSelectValue(newValue);
        if (typeof onChange === 'function') onChange(newValue);
    }

    useEffect(() => {
        const escapeListener = (e) => {
            if (isOpen && e.key === 'Escape') setOpen(false);
            if (!isOpen) window.removeEventListener('keydown', escapeListener);
        }
        window.addEventListener('keydown', escapeListener);
        return () => {
            window.removeEventListener('keydown', escapeListener);
        }
    });

    useEffect(() => {
        if (isOpen) {
            const outsideListener = (e) => {
                setOpen(false);
                window.removeEventListener('mousedown', outsideListener);
            }
            window.addEventListener('mousedown', outsideListener);
            return () => {
                window.removeEventListener('keydown', outsideListener);
            }
        }
    }, [isOpen]);

    useEffect(() => {
        setSelectValue(value);
        if (typeof onChange === 'function' && value) onChange(value);
    }, [value]);

    return (
        <Dropdown
            position={position}
            isOpen={isOpen}
            target={
                <Button
                    type={type}
                    onClick={toggleOpen}
                    className={'ignore-react-onclickoutside ' + (isOpen ? ' is-open' : '')}
                >
                    {title ? title + ': ' : ''}{selectValue ? selectValue.label : 'Select...'}
                    <span><ChevronDownIcon height={20} width={20} /></span>
                </Button>
            }
        >
            <Select
                autoFocus
                isSearchable={false}
                menuIsOpen
                className={'ch-borderless-select'}
                classNamePrefix={'ch-borderless-select'}
                onChange={handleSelectChange}
                options={options}
                tabSelectsValue={false}
                value={selectValue}
            />
        </Dropdown>
    )
}

const Dropdown = props => {
    const {position, children, isOpen, target} = props;
    return (
        <div className={'ch-button-select' + (position === 'right' ? ' ch-button-select-right' : '')}>
            {target}
            {isOpen ? <div className={'ch-button-select-menu'} style={{maxWidth: 400}}>{children}</div> : null}
        </div>
    )
}

export default ButtonSelect;